<template>
  <div class="custom-misc-page">
    <div class="content-wrap text-center">
      <h2 class="page-title">Under Maintenance! ⚙️</h2>
      <p class="page-subtitle">Sorry for the inconvenience but we're performing some maintenance at the moment</p>
      <b-button variant="primary" class="home-btn" to="/dashboard">Back to home</b-button>
      <b-img fluid class="hero-image" src="/maintenance.png" alt="Under maintenance page" />
    </div>
  </div>
</template>

<script>
import { BButton, BImg } from 'bootstrap-vue'

export default {
  components: {
    BButton,
    BImg,
  },
}
</script>

<style scoped lang="scss">
.custom-misc-page {
  min-height: 100vh;
  background: #f7f7fb;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem;
}

.content-wrap {
  width: min(760px, 100%);
}

.page-title {
  color: #5f6274;
  font-size: clamp(1.8rem, 2.8vw, 2.2rem);
  font-weight: 700;
  margin-bottom: 0.45rem;
}

.page-subtitle {
  color: #8b8f9f;
  font-size: 1rem;
  margin-bottom: 1.2rem;
}

.home-btn {
  margin-bottom: 1.7rem;
  background: #001a3b !important;
  border-color: #001a3b !important;
  padding: 0.55rem 1.2rem !important;
}

.hero-image {
  width: min(560px, 100%);
}
</style>
